module.exports = __webpack_public_path__ + "static/media/ic_tablet_active.1cd2a852.svg";